export const PREFERENCES_MENU_ITEMS = [
    { id: 'whats-new', label: "What's New", icon: 'asterisk', order: 0 },
    { id: 'account', label: 'Account', icon: 'user', order: 1 },
    { id: 'general', label: 'General', icon: 'settings', order: 3 },
    { id: 'security', label: 'Security', icon: 'security', order: 4 },
    { id: 'backups', label: 'Backups', icon: 'restore', order: 5 },
    { id: 'appearance', label: 'Appearance', icon: 'themes', order: 6 },
    { id: 'listed', label: 'Listed', icon: 'listed', order: 7 },
    { id: 'shortcuts', label: 'Shortcuts', icon: 'keyboard', order: 8 },
    { id: 'plugins', label: 'Plugins', icon: 'dashboard', order: 8 },
    { id: 'accessibility', label: 'Accessibility', icon: 'accessibility', order: 9 },
    { id: 'get-free-month', label: 'Get a free month', icon: 'star', order: 10 },
    { id: 'help-feedback', label: 'Help & feedback', icon: 'help', order: 11 },
];
export const READY_PREFERENCES_MENU_ITEMS = [
    { id: 'whats-new', label: "What's New", icon: 'asterisk', order: 0 },
    { id: 'account', label: 'Account', icon: 'user', order: 1 },
    { id: 'general', label: 'General', icon: 'settings', order: 3 },
    { id: 'security', label: 'Security', icon: 'security', order: 4 },
    { id: 'backups', label: 'Backups', icon: 'restore', order: 5 },
    { id: 'appearance', label: 'Appearance', icon: 'themes', order: 6 },
    { id: 'listed', label: 'Listed', icon: 'listed', order: 7 },
    { id: 'plugins', label: 'Plugins', icon: 'dashboard', order: 8 },
    { id: 'help-feedback', label: 'Help & feedback', icon: 'help', order: 11 },
];
